import client from '../../client';

const BUYER_ALERTS = {
  getBuyerAlerts(saleUniqueHash, price) {
    return client.get(`/sales/${saleUniqueHash}/buyer_alerts?price=${price}`);
  },
}

export default BUYER_ALERTS;
